const decodeQueryString = (queryString) => {
    return JSON.parse('{"' + decodeURI(queryString.slice(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
};
/**
 arrayToDataTable takes 2 arguments
 @param { Object[] } array
 @param { string[] } column_names
 converts the given array of objects in a dataFrame (list of lists)
 the column names are defaulting to the attribute names of the objects
 if column_names is not provided
 */
export const arrayToDataTable = (array, column_names = null) => {
    let dataTable = [];
    if (!array || array.length === 0)
        return dataTable;
    for (let i = 0; i < array.length; i++) {
        if (i === 0) {
            if (column_names != null)
                dataTable.push(column_names);
            else dataTable.push(Object.keys(array[i]));
        }
        dataTable.push(Object.values(array[i]));
    }
    return dataTable;
};

export default {
    decodeQueryString
};
